import React, { useEffect, useMemo } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './popup.scss';

const Popup = ({ children, className }) => {
  const el = useMemo(() => document.createElement('div'), []);

  const InnerComponent = () => (
    <div className={classNames('popup', className)}>
      {children}
    </div>
  );

  useEffect(() => {
    document.body.appendChild(el);

    return () => {
      document.body.removeChild(el);
    };
  }, [el]);

  return ReactDOM.createPortal(<InnerComponent />, el);
};

Popup.defaultProps = {
  className: '',
};

Popup.propTypes = {
  className: PropTypes.string,
};

export default Popup;
